import { createSlice } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import { API } from 'api';
import { getStatesWithCities, getOnlyCities } from 'utils/location';
import { getUIVersion } from 'utils/router-static-data';

const initialState = {
	statesWithCites: {},
	cities: [],
};

export const clientSlice = createSlice({
	name: 'clientState',
	initialState,
	reducers: {
		setStatesWithCites: (state, { payload = {} }) => {
			state.statesWithCites = payload;
		},
		setCities: (state, { payload = [] }) => {
			state.cities = payload;
		},
	},
});

export const getClientList =
	({ search_type = '', limit = 10, offset = 10, currentPage, ...rest }) =>
	async () => {
		console.log('limit', limit);
		console.log('offset', offset);

		// Use v2 API for project, vendor, driver, trip when in new UI
		const isV2UI = getUIVersion() === 'new';
		const v2SearchTypes = ['project', 'vendor', 'driver', 'trip'];
		const useV2 = isV2UI && v2SearchTypes.includes(search_type);

		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				// offset,
				// limit,
				...rest,
			},
			...(useV2 && { version: 'v2' }),
		};

		const response = await API.common(CREDENTIALS);

		// Transform v2 trip response to v1 format
		if (useV2 && search_type === 'trip' && response?.data?.trips) {
			const { transformTripListResponseV2ToV1 } = await import(
				'../utils/tripV2Transformations'
			);
			const transformed = transformTripListResponseV2ToV1(response);
			// Return in v1 format: { data: [...] }
			return {
				...response,
				data: transformed.rows || [],
			};
		}

		// For other v2 search types, transform response structure if needed
		if (useV2 && search_type === 'project' && response?.data?.projects) {
			return {
				...response,
				data: response.data.projects || [],
			};
		}
		if (useV2 && search_type === 'vendor' && response?.data?.vendors) {
			return {
				...response,
				data: response.data.vendors || [],
			};
		}
		if (useV2 && search_type === 'driver' && response?.data?.drivers) {
			return {
				...response,
				data: response.data.drivers || [],
			};
		}

		// Return response as-is for v1 or other cases
		return response;
	};

export const addClient =
	({ req_data, setErrors }) =>
	async () => {
		// console.log('setErrors', setErrors);

		const data = {
			create_type: 'client',
			data: {
				password: req_data?.data?.password,
				client_info: req_data?.data,
			},
		};

		console.log(data);

		const CREDENTIALS = {
			url: '/create',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			toaster.success('Client added successfully');
			return res;
		});
	};

export const updateInfoClient =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		let data = {};
		data = {
			update_type: 'client',
			id: req_data?.ids?.id,
			data: {
				id: req_data?.ids?.id,
				client_info: req_data?.data,
			},
		};
		console.log(data);
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);
		return API.common(CREDENTIALS).then((res) => res);
	};

export const updateClient =
	({ req_data, setErrors }) =>
	async () => {
		console.log(req_data);
		let data = {};
		data = {
			update_type: 'client',
			id: req_data?.id,
			data: {
				...req_data,
			},
		};
		console.log(data);
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		console.log(CREDENTIALS);
		return API.common(CREDENTIALS).then((res) => res);
	};

export const getLocations =
	({ search_type = '', filter_by = {} }) =>
	async (dispatch) => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				offset: 0,
				limit: 1000,
				filter_by: {
					...filter_by,
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			const citiesOnly = getOnlyCities(response);
			const statesAndCities = getStatesWithCities(response);
			console.log('citiesOnly', citiesOnly);

			dispatch(setCities(citiesOnly));
			dispatch(setStatesWithCites(statesAndCities));

			return response;
		});
	};
const generate_report = '/generate-report';

export const getCRF =
	({ id, type, setErrors }) =>
	async () => {
		console.log(id, type);
		const apiData = {
			report_type: 'client_registration_form',
			file_type: 'file',
			data: {
				id,
				url_type: 'download',
				doc_type: type,
			},
		};
		const CREDENTIALS = {
			url: generate_report,
			data: apiData,
			setErrors,
			aclBlockApiCall: false,
		};
		console.log(CREDENTIALS, id, type);
		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			window.open(res?.data?.download_url);
		});
	};
export const getUserTypes =
	({ data }) =>
	async () => {
		console.log('data', data);
		const url = '/search';
		const CREDENTIALS = {
			url,
			data: {
				search_type: 'user_type',
				...data,
			},
			showLoading: false,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((response) => response?.data || []);
	};
export const { setStatesWithCites, setCities } = clientSlice.actions;
export default clientSlice.reducer;
